"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoWithdrawalError = exports.MINIMUM_WITHDRAWAL_USD = void 0;
exports.MINIMUM_WITHDRAWAL_USD = 10;
var CryptoWithdrawalError;
(function (CryptoWithdrawalError) {
    CryptoWithdrawalError["notCryptoProduct"] = "notCryptoProduct";
    CryptoWithdrawalError["invalidAmount"] = "invalidAmount";
    CryptoWithdrawalError["accountRestricted"] = "accountRestricted";
    CryptoWithdrawalError["withdrawalHoldActive"] = "withdrawalHoldActive";
    CryptoWithdrawalError["exceedsMaxWithdrawable"] = "exceedsMaxWithdrawable";
    CryptoWithdrawalError["belowMinimumUsdValue"] = "belowMinimumUsdValue";
    CryptoWithdrawalError["inAchHold"] = "inAchHold";
})(CryptoWithdrawalError || (exports.CryptoWithdrawalError = CryptoWithdrawalError = {}));
